import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, MenuProps } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { ActionsDropdownProps } from './ActionsDropdown.interface';

export const ActionsDropdown: React.FC<ActionsDropdownProps> = ({
  onClickEditOption,
  onClickDeleteOption,
  onClickPreviewOption,
  hideDelete = false,
  onClickDuplicateOption,
  deleteLabel,
  disabled,
  customOptions,
}) => {
  const customOptionsItems = customOptions?.map((option, index) => ({
    key: `CUSTOM_OPTION_${index}`,
    label: option.label,
    icon: option.icon,
    onClick: option.onClick,
    style: { display: 'inherit' },
    disabled,
  }));

  const items: MenuProps['items'] = [
    {
      key: 'PREVIEW',
      label: 'Visualizar',
      icon: <EyeOutlined />,
      style: { display: onClickPreviewOption ? 'inherit' : 'none' },
      onClick: onClickPreviewOption,
      disabled,
    },
    {
      key: 'EDIT',
      label: 'Editar',
      icon: <EditOutlined />,
      style: { display: onClickEditOption ? 'inherit' : 'none' },
      onClick: onClickEditOption,
      disabled,
    },
    hideDelete
      ? null
      : {
          key: 'DELETE',
          label: deleteLabel ?? `Apagar`,
          icon: <DeleteOutlined />,
          style: { display: onClickDeleteOption ? 'inherit' : 'none' },
          danger: !disabled,
          onClick: onClickDeleteOption,
          disabled,
        },
    {
      key: 'DUPLICATE',
      label: 'Duplicar',
      icon: <CopyOutlined />,
      style: { display: onClickDuplicateOption ? 'inherit' : 'none' },
      onClick: onClickDuplicateOption,
      disabled,
    },
    ...(customOptionsItems ?? []),
  ];

  return (
    <Dropdown
      disabled={disabled}
      placement='bottomRight'
      menu={{ items }}
      trigger={['click']}
    >
      <CustomButton
        disabled={disabled}
        data-testid='menu-test'
        style={{ border: 'none' }}
      >
        <MoreOutlined />
      </CustomButton>
    </Dropdown>
  );
};

export type { ActionsDropdownProps };

const CustomButton = styled(Button)`
  &:hover {
    background-color: rgba(62, 62, 62, 0.7);
    color: white;
  }
`;
